<template>
    <div class="basic_wrap mt44">
        
        <baseHeader :title="$t('moneybag.withdrawRecord')"></baseHeader>
        <userInfo></userInfo>
        
        <div class="detail_box">
            <van-empty :description="$t('item.noData')" v-if="listShow"/>
            <div class="item" v-for="item in data">
                <div class="de_wrap">
                    <p class="tit">{{ item[lang] }}</p>
                    <template v-if="item.remark!=''"><p class="time">{{ $t('cash.remark') }}:{{ item.remark }}</p>
                    </template>
                    <p class="time">{{ item.time }}</p>
                </div>
                <div class="price" :class="item.type =='1'?'':'del'"
                     v-html="item.type =='1'?$t('utils.moneyMark')+item.money : '-'+$t('utils.moneyMark')+item.money"></div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Fetch from '../../utils/fetch'
import {
    DropdownMenu,
    DropdownItem
} from 'vant';

import {Empty} from 'vant';
import baseHeader from "@/components/baseHeader";

Vue.use(Empty);
Vue.use(DropdownMenu).use(DropdownItem);
import userInfo from "@/components/userInfo";

export default {
    name: "withdrawRecord",
    data() {
        return {
            lang: this.$i18n.locale || "zh_cn",
            data: [],
            list: {},
            account: 0,
            option: [],
            listShow: false,
            funds: 0,
            mymoney: 0,
            userName: ''
        };
    },
    components: {
        userInfo, baseHeader
    },
    created() {
        this.$parent.footer('user', false);
    },
    mounted() {
        Fetch('/user/funds', {
            reason_id: 2
        }).then(r => {
            this.option.push({
                text: this.$t('moneybag.types'),
                value: 0
            })
            
            this.showError(r.data.list.length);
            this.data = r.data.list;
            this.funds = r.data.money;
            this.mymoney = r.data.mymoney;
            this.userName = r.data.username;
        })
    },
    methods: {
        showError(len) {
            len == 0 ? this.listShow = true : this.listShow = false
        }
    }
};
</script>

<style lang="less" scoped>
.red_top_bg {
    position: fixed;
}

.detail_box {
    width: 96%;
    margin-left: 2%;
    background: #2B3864;
    border-radius: 6px;
    padding: 0 8px;
    margin-top: 15px;
    
    .item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 8px;
        border-bottom: 1px solid #3A4A7C;
        
        .de_wrap {
            flex: 2;
            
            .tit {
                font-size: 14px;
                color: white;
                line-height: 20px;
                font-weight: bold;
            }
            
            .time {
                font-size: 12px;
                color: white;
                line-height: 17px;
                margin-top: 10px;
            }
        }
        
        .price {
            flex: 1;
            font-size: 20px;
            line-height: 28px;
            font-weight: bold;
            text-align: right;
            color: #f12211;
            white-space: nowrap;
            
            &.del {
                color: #3FAF3E;
            }
        }
    }
}
</style>
